import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'
import modules from './modules';
import { setLocal, getLocal } from "../config/utils";

Vue.use(Vuex);

const state = {
    lang: "zh-CN",
    currency_root: "USD",
};
const plugin = store => {
        store.subscribe((mutation, state) => {
            ['register', 'operation'].map((item) => {
                if (mutation.type.indexOf(item) != -1) {
                    setLocal(item, state[item]);
                }
            })
        })
    }
    // if(getLocal('state'))Object.assign(state,getLocal('state'));
export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    modules,
    plugins: [plugin]
})


// WEBPACK FOOTER //
// ./src/store/index.js